import React from 'react';
import { isNil } from 'lodash';
import PropTypes from 'prop-types';
import { PipelineIntegrationsTableCountTitle } from './PiplineIntegrationsTableCountTitle';
import PipelineIntegrationsTableStatusTitle from './PipelineIntegrationsTableStatusTitle';

export default function PipelineIntegrationsTableTitle({ pipeline, tableData }) {
  // Tech Debt: This is tech debt because there are two different data models for pipeline
  // on the new pipeline page, we moved the data stitching complexity to the API so `status`
  // is on the pipeline. But that's not the case for the other place this table is used
  // this can be removed when we roll out the pipeline revamp and this component is only
  // used on the pipeline-details page.
  if (isNil(pipeline.status)) {
    return <PipelineIntegrationsTableCountTitle tableData={tableData} />;
  }

  return <PipelineIntegrationsTableStatusTitle pipeline={pipeline} />;
}

PipelineIntegrationsTableTitle.propTypes = {
  pipeline: PropTypes.shape({
    status: PropTypes.string.isRequired,
  }),
  tableData: PipelineIntegrationsTableCountTitle.propTypes.tableData,
};
